export default "__VITE_ASSET__CR45U2IR__"